module.exports = __webpack_public_path__ + "img/Frame13.d4331e18.png";